import axios from 'axios'
import { API_URL } from './index'
import { REQUEST_DELTA, RECEIVE_DELTA } from '../constants/ActionTypes'

//= ===============================
// Fetch One Delta Action
//= ===============================

const requestDelta = (report_id) => {
	return {
		type: REQUEST_DELTA,
		report_id
	}
}

const receiveDelta = (report_id, response) => {
	return {
		type: RECEIVE_DELTA,
		report_id,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchDelta = (report_id) => {
	return dispatch => {
		dispatch(requestDelta(report_id))
		let url = `${API_URL}/story/` + report_id + `?type=quill`
		axios.get(url)
		.then((response) => {
			dispatch(receiveDelta(report_id, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

export const loadDelta = (report_id) => (dispatch, getState) => {
	return dispatch(fetchDelta(report_id))
}


// WEBPACK FOOTER //
// ./src/actions/delta.js